<template>
	<div>
		<el-row style="padding: 0.7%0%;" class="flex align-content back-color-Bluebiack">
			<el-col :span="4" :offset="2"><img src="../../assets/img/loge.png" style="height: 60px;"></el-col>
			<el-col :span="8" :offset="2">
				<div class="textherd">
					<router-link to="/" tag="span"><el-link :underline="false">首页</el-link></router-link> 
					<router-link to="/SecondPage" tag="span" class="margin-left-lt"><el-link :underline="false">轨迹查询</el-link></router-link>
					<!-- <router-link to="/queryok" tag="span" class="margin-left-lt"><el-link :underline="false">关于我们</el-link></router-link> -->
				</div>
			</el-col>
			<el-col :span="3" :offset="3" style="margin-top: 2%;">
				<router-link to="/log/login" tag="span" class="textherds"><el-link :underline="false" style="color: #FD9405;font-size: 20px;">登录</el-link></router-link>
				<router-link to="/log/register" tag="span" class="textherds"><el-link :underline="false" style="	color: #FD9405;font-size: 20px;" >注册</el-link>
				</router-link>
			</el-col>
		</el-row>
	</div>
</template>

<script scoped>
import "@/assets/css/home.css"
import "@/assets/css/public.css"
	export default {
		name: 'Home',
		data() {
			return {};
		},
		mounted() {
		},
		methods: {
		}
	}
</script>

<style>
.textherd span{
	
}
</style>



// WEBPACK FOOTER //
// src/components/public/heard.vue